import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BannedAccountInterceptor } from 'core/interceptors/token/banned-account.interceptor';
import { RefreshTokenInterceptor } from 'core/interceptors/token/refresh-token.interceptor';
import { StateMatchersResolver } from 'root/extensions/extensions-resolvers';
import { RootStateResolver } from 'root/root-resolvers';
import { AssignedStatusesResolver, ProjectStatusesResolver } from 'root/user/user-resolvers';
import { CourierService } from './courier.service';
import { DocumentService } from './document.service';
import { ExtensionService } from './extension.service';
import { ProjectService } from './project.service';
import { StatusService } from './status.service';
import { WebhookService } from './webhook.service';

@NgModule({
  providers: [
    CourierService,
    DocumentService,
    ExtensionService,
    ProjectService,
    StatusService,
    WebhookService,
    RootStateResolver,
    StateMatchersResolver,
    ProjectStatusesResolver,
    AssignedStatusesResolver,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BannedAccountInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RefreshTokenInterceptor,
      multi: true,
    },
  ],
})
export class RootServicesModule {
}
